module.exports = __webpack_public_path__ + "static/Dynamo-561e452d28ef3ac1444c14c267c478f9.png";